export const tutorialPl = {
    'tutorial.list.workforce.title': 'Przydziel pracowników',
    'tutorial.list.workforce.description':
        'Zatrudnij drwali i asystentów, aby uruchomić przepływ drewna.',
    'tutorial.list.workforce.steps.jobs.title': 'Przydziel pracowników',
    'tutorial.list.workforce.steps.jobs.description': 'Zatrudnij drwali i asystentów.',
    'tutorial.list.weapons.title': 'Wykuj pierwszą broń',
    'tutorial.list.weapons.description': 'Zbuduj kuźnię i wytwórz pierwszą broń.',
    'tutorial.list.weapons.steps.setup.title': 'Zbuduj przemysł',
    'tutorial.list.weapons.steps.setup.description': 'Postaw wytapiarkę i kuźnię.',
    'tutorial.list.weapons.steps.production.title': 'Wykuj broń',
    'tutorial.list.weapons.steps.production.description': 'Wyprodukuj pierwszą partię broni.',
    'tutorial.list.starvation.title': 'Zapasy żywności',
    'tutorial.list.starvation.description': 'Wyjdź z niedoboru żywności i zatrzymaj głód.',
    'tutorial.list.starvation.steps.outlook.title': 'Sprawdź prognozę żywności',
    'tutorial.list.starvation.steps.outlook.description': 'Przejrzyj zapasy żywności i braki.',
    'tutorial.list.starvation.steps.jobs.title': 'Przydziel pracowników żywności',
    'tutorial.list.starvation.steps.jobs.description': 'Zatrudnij rolników i myśliwych.',
    'tutorial.list.cold.title': 'Zaopatrzenie w ciepło',
    'tutorial.list.cold.description': 'Wytwarzaj opał, aby zapobiec zamarzaniu.',
    'tutorial.list.cold.steps.outlook.title': 'Sprawdź prognozę ciepła',
    'tutorial.list.cold.steps.outlook.description': 'Przejrzyj zapotrzebowanie na ciepło i opał.',
    'tutorial.list.cold.steps.jobs.title': 'Przydziel palaczy',
    'tutorial.list.cold.steps.jobs.description': 'Zatrudnij palaczy i asystentów.',
    'tutorial.workforce.step1.title': 'Otwórz osadę',
    'tutorial.workforce.step1.body': 'Kliknij podświetlone miasto, aby otworzyć szczegóły.',
    'tutorial.workforce.step2.title': 'Przejdź do zakładki Prace',
    'tutorial.workforce.step2.body': 'Otwórz zakładkę Prace, aby zarządzać pracownikami.',
    'tutorial.workforce.step3.title': 'Przydziel drwali',
    'tutorial.workforce.step3.body': 'Zatrudnij %d drwali, aby zacząć ścinać drzewa.',
    'tutorial.workforce.step4.title': 'Sprawdź produkcję',
    'tutorial.workforce.step4.body': 'Przejdź do Produkcji, aby zobaczyć drewno.',
    'tutorial.workforce.step5.title': 'Wróć do Prac',
    'tutorial.workforce.step5.body': 'Wróć do Prac, aby przydzielić asystentów.',
    'tutorial.workforce.step6.title': 'Przydziel asystentów',
    'tutorial.workforce.step6.body': 'Zatrudnij %d asystentów do przenoszenia drewna.',
    'tutorial.workforce.step7.title': 'Sprawdź magazyn',
    'tutorial.workforce.step7.body': 'Otwórz Magazyn, aby zobaczyć zebrane zasoby.',
    'tutorial.starvation.step1.title': 'Otwórz osadę',
    'tutorial.starvation.step1.body': 'Kliknij podświetlone miasto, aby sprawdzić zapasy żywności.',
    'tutorial.starvation.step2.title': 'Sprawdź prognozę żywności',
    'tutorial.starvation.step2.body': 'Otwórz zakładkę Populacja, aby zobaczyć braki żywności.',
    'tutorial.starvation.step3.title': 'Przejdź do zakładki Prace',
    'tutorial.starvation.step3.body': 'Otwórz Prace, aby przydzielić pracowników żywności.',
    'tutorial.starvation.step4.title': 'Otwórz prace żywności',
    'tutorial.starvation.step4.body': 'Przełącz na zakładkę Żywność.',
    'tutorial.starvation.step5.title': 'Przydziel rolników',
    'tutorial.starvation.step5.body': 'Zatrudnij %d rolników do produkcji żywności.',
    'tutorial.starvation.step6.title': 'Przydziel myśliwych',
    'tutorial.starvation.step6.body': 'Zatrudnij %d myśliwych do zdobywania żywności.',
    'tutorial.starvation.step7.title': 'Przydziel asystentów',
    'tutorial.starvation.step7.body': 'Zatrudnij %d asystentów do przenoszenia żywności.',
    'tutorial.starvation.step8.title': 'Wróć do prognozy żywności',
    'tutorial.starvation.step8.body': 'Wróć do zakładki Populacja, aby potwierdzić poprawę.',
    'tutorial.cold.step1.title': 'Otwórz osadę',
    'tutorial.cold.step1.body': 'Kliknij podświetlone miasto, aby sprawdzić ogrzewanie.',
    'tutorial.cold.step2.title': 'Sprawdź prognozę ciepła',
    'tutorial.cold.step2.body':
        'Otwórz zakładkę Populacja, aby zobaczyć zapotrzebowanie na ciepło.',
    'tutorial.cold.step3.title': 'Przejdź do zakładki Prace',
    'tutorial.cold.step3.body': 'Otwórz Prace, aby przydzielić palaczy.',
    'tutorial.cold.step4.title': 'Otwórz prace przemysłu',
    'tutorial.cold.step4.body': 'Przełącz na zakładkę Przemysł.',
    'tutorial.cold.step5.title': 'Przydziel palaczy',
    'tutorial.cold.step5.body': 'Zatrudnij %d palaczy do produkcji węgla drzewnego.',
    'tutorial.cold.step6.title': 'Przydziel asystentów',
    'tutorial.cold.step6.body': 'Zatrudnij %d asystentów do przenoszenia opału.',
    'tutorial.cold.step7.title': 'Wróć do prognozy ciepła',
    'tutorial.cold.step7.body': 'Wróć do zakładki Populacja, aby potwierdzić poprawę.',
    'tutorial.weapons.step1.title': 'Otwórz osadę',
    'tutorial.weapons.step1.body': 'Kliknij podświetlone miasto, aby zacząć.',
    'tutorial.weapons.step2.title': 'Otwórz zakładkę Budynki',
    'tutorial.weapons.step2.body': 'Przejdź do Budynków, aby rozpocząć budowę.',
    'tutorial.weapons.step3.title': 'Otwórz budynki rzemiosła',
    'tutorial.weapons.step3.body': 'Wybierz podzakładkę Rzemiosło.',
    'tutorial.weapons.step4.title': 'Zbuduj kuźnię',
    'tutorial.weapons.step4.body': 'Dodaj kuźnię do kolejki budowy.',
    'tutorial.weapons.step5.title': 'Otwórz budynki wsparcia',
    'tutorial.weapons.step5.body': 'Przełącz na podzakładkę Wsparcie.',
    'tutorial.weapons.step6.title': 'Zbuduj koszary',
    'tutorial.weapons.step6.body': 'Dodaj koszary do kolejki.',
    'tutorial.weapons.step7.title': 'Otwórz zakładkę Prace',
    'tutorial.weapons.step7.body': 'Przejdź do Prac, aby przydzielić pracowników.',
    'tutorial.weapons.step8.title': 'Otwórz prace rzemiosła',
    'tutorial.weapons.step8.body': 'Przełącz na podzakładkę Rzemiosło.',
    'tutorial.weapons.step9.title': 'Przydziel kowala',
    'tutorial.weapons.step9.body': 'Zatrudnij kowala do produkcji broni.',
    'tutorial.weapons.step10.title': 'Otwórz zakładkę Produkcja',
    'tutorial.weapons.step10.body': 'Przejdź do Produkcji, aby ustawić kuźnię.',
    'tutorial.weapons.step11.title': 'Ustaw cel narzędzi',
    'tutorial.weapons.step11.body': 'Ustaw cel narzędzi na %d.',
    'tutorial.weapons.step12.title': 'Ustaw cel broni',
    'tutorial.weapons.step12.body': 'Ustaw cel broni na %d.',
    'tutorial.weapons.step13.title': 'Wróć do Prac',
    'tutorial.weapons.step13.body': 'Wróć do Prac, aby przydzielić wsparcie.',
    'tutorial.weapons.step14.title': 'Otwórz prace wsparcia',
    'tutorial.weapons.step14.body': 'Przełącz na podzakładkę Wsparcie.',
    'tutorial.weapons.step15.title': 'Przydziel milicję',
    'tutorial.weapons.step15.body': 'Zatrudnij %d milicji do zwiadu.',
    'tutorial.weapons.step16.title': 'Sprawdź broń',
    'tutorial.weapons.step16.body': 'Otwórz Produkcję i sprawdź postęp broni.',
    'tutorial.weapons.step17.title': 'Otwórz wrogi teren',
    'tutorial.weapons.step17.body': 'Kliknij podświetlony region z wrogami.',
    'tutorial.weapons.step18.title': 'Otwórz zwiad',
    'tutorial.weapons.step18.body': 'Rozpocznij misję zwiadowczą.',
    'tutorial.weapons.step19.title': 'Wyślij zwiad',
    'tutorial.weapons.step19.body': 'Ustaw oddziały i wyślij zwiad.',
    'tutorial.weapons.step20.title': 'Zobacz raport bitwy',
    'tutorial.weapons.step20.body': 'Otwórz szczegóły bitwy.',
    'tutorial.weapons.step21.title': 'Wróć z oddziałami',
    'tutorial.weapons.step21.body': 'Każ zwiadowcom wrócić.',
    'tutorial.done.title': 'Samouczek ukończony',
    'tutorial.done.body': 'Świetnie! Zakończ samouczek, gdy będziesz gotowy.',
};

export default tutorialPl;
